import { render, staticRenderFns } from "./bdmItemList.vue?vue&type=template&id=735563ec&scoped=true"
import script from "./bdmItemList.vue?vue&type=script&lang=js"
export * from "./bdmItemList.vue?vue&type=script&lang=js"
import style0 from "./bdmItemList.vue?vue&type=style&index=0&id=735563ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735563ec",
  null
  
)

export default component.exports